import React, { useEffect, useState } from 'react'
import { notify } from '@/_helpers'
import { API, NoContentBox, Help } from '@enkla-gui'

export default function FortnoxIntegrationCallback() {
	const params = new URLSearchParams(window.location.search)
	const [loading, setLoading] = useState(true)
	const [error, setError] = useState(false)

	useEffect(() => {
		API.post('api/fortnox/authenticate', {
			state: params.get('state'),
			code: params.get('code')
		})
			.then(res => {
				notify.toast('Integration kopplad')
				setLoading(false)
				window.location.hash = '#!/integration/overview'
			})
			.catch(([err, res]) => {
				notify.toast(res, 'error')
				setLoading(false)
				setError(true)
			})
		params.delete('state')
		params.delete('code')
		window.history.replaceState({}, '', `${window.location.pathname}${params}${window.location.hash}`)
	}, [])

	return (
		<div class='container-absolute-center'>
			{loading && <NoContentBox text='Integrerar...' icon='fa-circle-notch fa-spin' />}
			{error && (
				<div class="text-center">
					<NoContentBox
						text='Det gick inte att ansluta Fortnox. Säkerställ att du har en integrationslicens och försök igen.'
						icon='fa-exclamation-triangle'
					/>
					<a href='https://support.fortnox.se/komigangguide-tjanster/kom-igang-med-partner-appar' target='_blank' rel="noreferrer" >
						Klicka här för att läsa mer om Fortnox integrationslicens
					</a>
				</div>
			)
			}
			{
				!loading && !error && <div class="text-center">
					<Help type='info'>
						<p>Fortnox är nu integrerat med Enkla Fastigheter!</p>
						<b>För att kunna skapa fakturor krävs det att du har ett aktivt räkneskapsår i Fortnox</b>
						<hr />
						<p>Enkla Fastigheter bokför på följande konton</p>
						<ul style={{ 'listStyle': 'none' }}>
							<li>
								0% moms = konto 3004
							</li>
							<li>
								6% moms = konto 3003
							</li>
							<li>
								12% moms = konto 3002
							</li>
							<li>
								25% moms = konto 3001
							</li>
						</ul>
					</Help>
				</div>
			}
		</div >
	)
}
